<template>
  <div class="container-fluid main checkout-page premium-checkout-page">
    <!--        <code>{{timeSlots}}</code>-->
    <!--        <code>{{locations}}</code>-->
    <div class="col-md-12">
      <div class="col-md-8 col-md-offset-2">
      <div class="row" v-if="!logged_in_user_name">
        <div class="col-md-12 login-sec">
          <div class="login-note">
            <h3 class="pull-left">
              <i class="fa fa-exclamation-triangle"></i> If You are a registered customer
              please log in..
            </h3>
            <button
              data-toggle="modal"
              data-target="#loginModal"
              class="btn btn-blank pull-right"
            >
              Login
            </button>
          </div>
        </div>
      </div>
      <div class="customer-details mt30">
        <div class="checkout-layout">
          <div class="col-md-6 bill-info">
            <div v-if="globalLanguage == 'EN'">
              <h3 class="c-title" v-if="logged_in_user_name">Delivery Information</h3>
              <h3 class="c-title" v-else>Buy as a new Customer.</h3>
            </div>
            <div v-else>
              <h3 class="c-title bn" v-if="logged_in_user_name">ডেলিভারি তথ্য</h3>
              <h3 class="c-title bn" v-else>নতুন গ্রাহক হিসাবে পণ্য কিনুন।.</h3>
            </div>
            <div>
              <div>
                <div class="form-group">
                  <label v-if="globalLanguage == 'EN'">Full Name</label>
                  <label class="bn" v-else>আপনার পুরো নাম</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="name"
                    placeholder="Full Name"
                  />
                </div>
                <div class="form-group">
                  <label v-if="globalLanguage == 'EN'">Phone Number</label>
                  <label class="bn" v-else>আপনার ফোন নম্বর </label>
                  <div class="realtive-area">
                    <button
                      type="button"
                      v-if="!logged_in_user_name & buttonStatus"
                      class="btn btn-login otpbtn"
                      @click="sendOTPCode"
                    >
                      <i class="fa fa-rocket"></i>&nbsp;
                      <span v-if="globalLanguage == 'EN'">Send OTP Code</span
                      ><span v-else>সেন্ড ওটিপি </span>
                    </button>
                    <input
                      type="tel"
                      class="form-control checkephone"
                      @change="phoneNumbers"
                      v-model="phone"
                      pattern="[0-9]{10}"
                      placeholder="Your Phone Number"
                    />

                  </div>
                  <div v-if="!logged_in_user_name" class="help-text d-block">
                    ( e.g. Phone:0758514154)
                  </div>
                  <div
                    v-if="
                      (globalLanguage == 'EN') &
                      !logged_in_user_name &
                      (buttonStatus == true) &
                      (phone.length == 11)
                    "
                  >
                    Click send button to get to OTP code in your Mobile.
                  </div>
                  <div
                    v-if="
                      (globalLanguage == 'BN') &
                      !logged_in_user_name &
                      (buttonStatus == true) &
                      (phone.length == 11)
                    "
                  >
                    সেন্ড বাটন এ ক্লিক করুন মোবাইল এ ওটিপি পেতে.
                  </div>
                  <div class="smslabel phoneStatus" id="OtpSuccess"></div>
                </div>
                <div class="form-group" v-if="showOTPInput">
                  <label v-if="globalLanguage == 'EN'">Input 4-Digit Code here</label>
                  <label class="bn" v-else>এখানে চার-অঙ্কের কোড ইনপুট করুন</label>
                  <input
                    type="text"
                    class="form-control tokenField"
                    @keyup="verifyOTP"
                    v-model="otpCode"
                    placeholder="Input 4-Digit Code here"
                  />
                  <div class="smslabel" id="tokenSuccess"></div>
                </div>

                <div class="form-group" v-if="!logged_in_user_name">
                  <label v-if="globalLanguage == 'EN'">SET Password</label>
                  <label class="bn" v-else>পাসওয়ার্ড সেট করুন</label>
                  <input
                    type="password"
                    class="form-control"
                    v-model="password"
                    placeholder="Set Your Password"
                  />
                  <small class="help-text" v-if="globalLanguage == 'EN'"
                    >Set your Password Minimum 6 character Long.</small
                  >
                  <small class="help-text" v-else
                    >আপনার পাসওয়ার্ড মিনিমাম ছয় ক্যারেক্টার লং হতে হবে.</small
                  >
                </div>
                <div class="form-group">
                  <label v-if="globalLanguage == 'EN'">Select Your Area</label>
                  <label class="bn" v-else>আপনার এলাকা সিলেক্ট করুন </label>

                  <!--<Select2 v-model="area" @change="deliveryCharge()" :options="locations" :settings="{ settingOption: text, settingOption: id }"  />-->
                  <div class="areaInput">
                    <input
                      v-if="globalLanguage == 'EN'"
                      type="text"
                      class="form-control"
                      v-model="area"
                      @focus="toggle = !toggle"
                      readonly
                      placeholder="Select Your Area"
                    />
                    <input
                      v-else
                      type="text"
                      class="form-control"
                      v-model="area"
                      @focus="toggle = !toggle"
                      readonly
                      placeholder="আপনার এলাকা সিলেক্ট করুন "
                    />
                    <div class="close" @click="focusInput()">
                      <i aria-hidden="true" class="fa fa-angle-down"></i>
                    </div>
                  </div>
                  <div class="areaList" v-if="locations.length > 0 && toggle == true">
                    <div class="abs-area">
                      <div class="relative-area">
                        <button
                          @click="searchArea"
                          type="button"
                          class="btn btn-login otpbtn couponBtn"
                        >
                          <i class="fa fa-search"></i>&nbsp; <span> Search</span>
                        </button>
                        <input
                          type="text"
                          class="form-control"
                          ref="search"
                          v-model="searchByName"
                          placeholder="Search Area"
                        />
                      </div>
                      <ul>
                        <li
                          v-for="location in getSearchAreaList"
                          @click="
                            deliveryCharge(
                              location.location_id,
                              location.delivery_charge,
                              location.min_order_amount,
                              location.extraFastDeliveryCharge,
                              location.text,
                              location.delivery_time_slot,
                              location.buffering_time_slot
                            )
                          "
                        >
                          {{ location.text }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

<div v-if="min_order_amount > 0"  class="smslabel phoneStatus"><span ><i class="fa fa-exclamation-triangle"></i>
Minimum Order Amount for  selected area is <strong class="red-color">{{  min_order_amount }} €</strong></span></div>
                <div class="form-group">
                  <label v-if="globalLanguage == 'EN'">Shipping Address</label>
                  <label class="bn" v-else>আপনার ঠিকানা</label>
                  <textarea
                    id="address"
                    class="form-control shipping_address"
                    placeholder="Your Full Address"
                    name="shipping_address"
                  ></textarea>
                  <small v-if="globalLanguage == 'EN'"
                    >e.g. ( public hall Behind Hamdard Showroom )</small
                  >
                  <small v-else>যেমন ( পাবলিক হল মোর হামদর্দ এর গলির পিছে )</small>
                </div>
                <div class="form-group usedaddress">
                  <div
                    class="eachaddress"
                    v-for="previous_location in previous_locations"
                    @click="useThisAddress(previous_location.shipping_address)"
                  >
                    {{ previous_location.shipping_address }}
                    <span class="clickhand">
                      <span v-if="globalLanguage == 'EN'"
                        >Click to use this Address
                        <i class="fa fa-hand-pointer-o" aria-hidden="true"></i
                      ></span>
                      <span v-else
                        >এই ঠিকানা ব্যবহার করতে ক্লিক করুন
                        <i class="fa fa-hand-pointer-o" aria-hidden="true"></i
                      ></span>
                    </span>
                  </div>
                </div>
                <div class="form-group">
                  <label v-if="globalLanguage == 'EN'">HAVE A COUPON CODE? </label>
                  <label v-else class="bn">কুপন কোড থাকলে ব্যবহার করুন.</label>
                  <div v-if="extraFastCharge == false">
                    <div class="realtive-area">
                      <button
                        type="button"
                        class="btn btn-login otpbtn couponBtn"
                        :disabled="couponBtn == false"
                        @click="validate"
                      >
                        <i class="fa fa-rocket"></i>&nbsp; <span>VERIFY</span>
                      </button>
                      <input
                        type="text"
                        v-if="globalLanguage == 'EN'"
                        placeholder="Input Code Here"
                        v-model="coupon"
                        @change="validate"
                        class="form-control mb5"
                      />
                      <input
                        type="text"
                        v-else
                        placeholder="কোড ইনপুট দিন"
                        v-model="coupon"
                        @change="validate"
                        class="form-control mb5"
                      />
                    </div>
                    <div v-if="globalLanguage == 'EN'" class="text-uppercase">
                      <span class="help-text minimum_order blocktext"></span>
                      <span
                        class="help-text f13 red-color font-weight-bold"
                        v-if="
                          coupon_discount === 0 &&
                          productRestrictionBn == null &&
                          responseEN == null &&
                          extraFastCharge == false
                        "
                        ><img
                          width="15px"
                          class="tp1"
                          alt="icon"
                          src="@/assets/images/info-red.png"
                        />
                        Coupon is not valid.</span
                      >
                      <span
                        class="help-text f13 green-color font-weight-bold"
                        v-if="coupon_discount > 0 && extraFastCharge == false"
                        ><img
                          class="tp1"
                          width="15px"
                          alt="icon"
                          src="@/assets/images/info-green.png"
                        />
                        Discount {{ coupon_discount }} TK</span
                      >
                    </div>
                    <div class="" v-else>
                      <span
                        v-if="extraFastCharge == false"
                        class="help-text red-color font-weight-bold minimum_order blocktext"
                      ></span>
                      <span
                        class="help-text f13 font-weight-bold red-color"
                        v-if="
                          coupon_discount === 0 &&
                          productRestrictionBn === null &&
                          responseEN === null &&
                          extraFastCharge == false
                        "
                        ><img
                          class="tp1"
                          width="15px"
                          alt="icon"
                          src="@/assets/images/info-red.png"
                        />
                        কুপন কোড ভুল.</span
                      >
                      <div
                        v-if="
                          globalLanguage == '' || (globalLanguage == 'BN' && responseBN)
                        "
                      >
                        <span class="help-text f13 blocktext"
                          ><i class="fa fa-hand-o-right" aria-hidden="true"></i>
                          {{ responseBN }}</span
                        >
                      </div>
                      <span
                        class="help-text green-color f13 font-weight-bold"
                        v-if="coupon_discount > 0 && extraFastCharge == false"
                        ><img
                          class="tp1"
                          width="12px"
                          alt="icon"
                          src="@/assets/images/info-green.png"
                        />
                        ডিসকাউন্ট {{ coupon_discount }} টাকা
                      </span>
                    </div>
                    <div>
                      <div v-if="globalLanguage == 'EN' && responseEN">
                        <span class="help-text f13 blocktext"
                          ><i class="fa fa-hand-o-right" aria-hidden="true"></i>
                          {{ responseEN }}</span
                        >
                      </div>

                      <div v-if="globalLanguage == 'EN' && productRestrictionEn">
                        <span class="help-text f13 blocktext"
                          >Coupon code is not valid for.</span
                        >
                        <span
                          v-for="productRestrictionEn in productRestrictionEn"
                          class="help-text f13 blocktext"
                          ><i class="fa fa-hand-o-right" aria-hidden="true"></i>
                          {{ productRestrictionEn.name_en }}</span
                        >
                      </div>
                      <div
                        v-if="
                          globalLanguage == '' ||
                          (globalLanguage == 'BN' && productRestrictionBn)
                        "
                      >
                        <span class="help-text f13 blocktext"
                          >কুপন কোড বৈধ নয় যেসব পণ্যের জন্য.</span
                        >
                        <span
                          v-for="productRestrictionBn in productRestrictionBn"
                          class="help-text f13 blocktext"
                          ><i class="fa fa-hand-o-right" aria-hidden="true"></i>
                          {{ productRestrictionBn.name_bn }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <input
                      v-if="globalLanguage == 'EN'"
                      type="text"
                      disabled
                      placeholder="Coupon Unavailable for Extra Fast Delivery"
                      class="form-control"
                    />
                    <input
                      v-else
                      type="text"
                      disabled
                      placeholder="এক্সট্রা ফাস্ট ডেলিভারি নিতে কুপন প্রযোজ্য নয় "
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 bill-info">
            <h3 class="c-title" v-if="globalLanguage == 'EN'">Payment Method</h3>
            <h3 class="c-title bn" v-else>পেমেন্ট পদ্ধতি</h3>
            <div class="payment-options">
              <div class="each-option">
                <div class="radio radio-success" title="Cash On Delivery">
                  <input
                    type="radio"
                    name="radio2"
                    id="radio2"
                    v-model="payment_type"
                    value="2"
                  />
                  <label for="radio2">
                    <img src="@/assets/images/cash.png" />
                  </label>
                </div>
              </div>
              <div class="each-option">
                <div class="radio radio-success" title="Card">
                  <input
                    type="radio"
                    name="radio2"
                    v-model="payment_type"
                    id="radio1"
                    value="1"
                  />
                  <label for="radio1">
                    <img src="@/assets/images/atm-card.png" />
                  </label>
                </div>
               
              </div>
              
            </div>
            <div class="payment-options delivery_time_slot" v-if="delivery_time_slot">
              <div class="each-option">
                <div class="extra_first">
                  <div
                    class="pull-left"
                    @click="toogleTimeArea"
                    style="padding-right: 10px"
                  >
                    <img src="@/assets/images/icons/delivery-time.png" height="35px" />
                  </div>

                  <div class="pdt4" v-if="globalLanguage == 'EN'">
                    <div
                      @click="toogleTimeArea"
                      style="overflow: hidden; cursor: pointer"
                    >
                      <span style="font-weight: 500">
                        Your Preferred delivery time .<i
                          class="fa fa-angle-down pull-right"
                          style="font-size: 18px; margin-right: 10px; color: #000"
                        ></i
                      ></span>
                      <br />
                      <span
                        style="color: #e91e63; font-weight: 400"
                        v-if="expectedDeliveryTime"
                      >
                        <span
                          class="expectedDeliveryTime"
                          v-if="expectedDeliveryTimeEnable"
                        >
                          {{ expectedDeliveryTimeEnable }} {{ expectedDeliveryTime }}
                        </span>
                        <span class="expectedDeliveryTime" v-else>
                          {{ expectedDeliveryTime }}
                          {{ expectedDeliveryStartTime | formatHour }} -
                          {{ expectedDeliveryEndTime | formatHour }}
                        </span>
                      </span>
                      <span
                        style="color: #e91e63; font-weight: 400"
                        v-if="expectedDeliveryTime == null"
                        >Delivery time not Set.</span
                      >
                    </div>
                    <div class="delivery-time" v-if="isActiveTime == true">
                      <div
                        class="single-slot"
                        v-for="(timeSlot, index) in timeSlots"
                        :class="{ disabled: timeSlot.status }"
                        @click="
                          DeliveryTimeSet(index, timeSlot.start, timeSlot.end, 'Today')
                        "
                      >
                        <div class="pull-left" style="padding-right: 10px">
                          <img
                            src="@/assets/images/icons/clock.png"
                            style="margin-top: 6px"
                            height="26px"
                          />
                        </div>
                        <div class="pdt4">
                          <span style="font-weight: 500"> Delivery Time </span>
                          <br />
                          <span style="color: #e91e63; font-weight: 400">
                            Today {{ timeSlot.start | formatHour }}
                            -
                            {{ timeSlot.end | formatHour }}</span
                          >
                        </div>
                      </div>
                      <div class="single-slot blackarea" @click="ToogleTomorrowTime()">
                        <div class="pull-left" style="padding-right: 10px">
                          <img
                            src="@/assets/images/icons/delivery-time-white.png"
                            style="margin-top: 6px"
                            height="26px"
                          />
                        </div>
                        <div class="pdt4">
                          <span style="font-weight: 500; color: #fff">
                            I want to take delivery Tomorrow
                            <i
                              class="fa fa-angle-down pull-right"
                              style="font-size: 18px; margin-right: 10px; color: #fff"
                            ></i
                          ></span>
                          <br />
                          <span style="color: rgb(233, 30, 99); font-weight: 400"
                            >Set Delivery time</span
                          >
                        </div>
                      </div>

                      <div
                        class="single-slot"
                        v-if="isActiveTomorrowTime == true"
                        v-for="(timeSlot, index) in timeSlots"
                        @click="
                          DeliveryTimeSet(index, timeSlot.start, timeSlot.end, 'Tomorrow')
                        "
                      >
                        <div class="pull-left" style="padding-right: 10px">
                          <img
                            src="@/assets/images/icons/clock.png"
                            style="margin-top: 6px"
                            height="26px"
                          />
                        </div>
                        <div class="pdt4">
                          <span style="font-weight: 500"> Delivery Time </span>
                          <br />
                          <span style="color: #e91e63; font-weight: 400"
                            >Tomorrow {{ tomorrow | tomorrowDayName }}
                            {{ timeSlot.start | formatHour }} -
                            {{ timeSlot.end | formatHour }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="pdt4" v-else>
                    <div
                      @click="toogleTimeArea"
                      style="overflow: hidden; cursor: pointer"
                    >
                      <span style="font-weight: 500">
                        পছন্দের ডেলিভারি সময় নির্বাচন করুন.<i
                          class="fa fa-angle-down pull-right"
                          style="font-size: 18px; margin-right: 10px; color: #000"
                        ></i
                      ></span>
                      <br />
                      <span
                        style="color: #e91e63; font-weight: 400"
                        v-if="expectedDeliveryTime"
                      >
                        <span
                          class="expectedDeliveryTime"
                          v-if="expectedDeliveryTimeEnable"
                        >
                          {{ expectedDeliveryTimeEnable }} {{ expectedDeliveryTime }}
                        </span>
                        <span class="expectedDeliveryTime" v-else>
                          {{ expectedDeliveryTime }}
                          {{ expectedDeliveryStartTime | formatHour }} -
                          {{ expectedDeliveryEndTime | formatHour }}
                        </span>
                      </span>
                      <span
                        style="color: #e91e63; font-weight: 400"
                        v-if="expectedDeliveryTime == null"
                        >সময় নির্বাচন করা হয়নি.</span
                      >
                    </div>
                    <div class="delivery-time" v-if="isActiveTime == true">
                      <div
                        class="single-slot"
                        v-for="(timeSlot, index) in timeSlots"
                        :class="{ disabled: timeSlot.status }"
                        @click="
                          DeliveryTimeSet(index, timeSlot.start, timeSlot.end, 'Today')
                        "
                      >
                        <div class="pull-left" style="padding-right: 10px">
                          <img
                            src="@/assets/images/icons/clock.png"
                            style="margin-top: 6px"
                            height="26px"
                          />
                        </div>
                        <div class="pdt4">
                          <span style="font-weight: 500"> ডেলিভারি সময় </span>
                          <br />
                          <span style="color: #e91e63; font-weight: 400">
                            Today {{ timeSlot.start | formatHour }}
                            -
                            {{ timeSlot.end | formatHour }}</span
                          >
                        </div>
                      </div>
                      <div class="single-slot blackarea" @click="ToogleTomorrowTime()">
                        <div class="pull-left" style="padding-right: 10px">
                          <img
                            src="@/assets/images/icons/delivery-time-white.png"
                            style="margin-top: 6px"
                            height="26px"
                          />
                        </div>
                        <div class="pdt4">
                          <span style="font-weight: 500; color: #fff">
                            আগামীকাল ডেলিভারি পেতে চাই.
                            <i
                              class="fa fa-angle-down pull-right"
                              style="font-size: 18px; margin-right: 10px; color: #fff"
                            ></i
                          ></span>
                          <br />
                          <span style="color: rgb(233, 30, 99); font-weight: 400">
                            ডেলিভারি সময় নির্বাচন করুন.</span
                          >
                        </div>
                      </div>
                      <div
                        class="single-slot"
                        v-if="isActiveTomorrowTime == true"
                        v-for="(timeSlot, index) in timeSlots"
                        @click="
                          DeliveryTimeSet(index, timeSlot.start, timeSlot.end, 'Tomorrow')
                        "
                      >
                        <div class="pull-left" style="padding-right: 10px">
                          <img
                            src="@/assets/images/icons/clock.png"
                            style="margin-top: 6px"
                            height="26px"
                          />
                        </div>
                        <div class="pdt4">
                          <span style="font-weight: 500"> ডেলিভারি সময় </span>
                          <br />
                          <span style="color: #e91e63; font-weight: 400"
                            >Tomorrow {{ tomorrow | tomorrowDayName }}
                            {{ timeSlot.start | formatHour }} -
                            {{ timeSlot.end | formatHour }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <!--                    <div @click="toogleTimeArea" style="overflow: hidden;">-->
                    <!--                      <span style="font-weight: 500;">-->
                    <!--                     পছন্দের ডেলিভারি সময় নির্বাচন করুন.<i class="fa fa-angle-down pull-right"-->
                    <!--                                                            style="font-size: 18px;margin-right: 10px;color: #000;"></i></span>-->
                    <!--                      <br/>-->
                    <!--                      <span style="color: #e91e63;font-weight: 400;"-->
                    <!--                            v-if="expectedDeliveryTime">{{ expectedDeliveryTime }}</span>-->
                    <!--                      <span style="color: #e91e63;font-weight: 400;" v-if="expectedDeliveryTime == null">সময় নির্বাচন করা হয়নি.</span>-->
                    <!--                    </div>-->
                    <!--                    <div class="delivery-time" v-if="isActiveTime == true">-->
                    <!--                      <div class="single-slot" v-for="(delivery_time, index)  in delivery_time_slot"-->
                    <!--                           @click="DeliveryTimeSet(index,delivery_time)">-->
                    <!--                        <div class="pull-left" style="padding-right: 10px"><img src="@/assets/images/icons/clock.png"-->
                    <!--                                                                                style="margin-top: 6px;"-->
                    <!--                                                                                height="26px"></div>-->
                    <!--                        <div class="pdt4">-->
                    <!--                    <span style="font-weight: 500;">-->
                    <!--                    ডেলিভারি সময়  </span>-->
                    <!--                          <br/> <span style="color: #e91e63;font-weight: 400;">{{ delivery_time }}</span>-->
                    <!--                        </div>-->
                    <!--                      </div>-->
                    <!--                    </div>-->
                  </div>
                </div>
              </div>
            </div>
            <div
              class="payment-options extraFastCharge"
              :class="{ active: extraFastCharge }"
              @click="extraFastChargeAssign"
              v-if="ShowextraFastDiv"
            >
              <div class="each-option">
                <div class="extra_first" title="Extra Fast Delivery">
                  <div class="pull-left" style="padding-right: 10px">
                    <img src="@/assets/images/extra-first.png" height="35px" />
                  </div>
                  <div class="pdt4" v-if="globalLanguage == 'EN'">
                    <span style="font-weight: 500">
                      Want to get Extra Fast Delivery?
                    </span>
                    <br />
                    <span style="color: #e91e63; font-weight: 400"
                      ><b> {{ extraFastDeliveryCharge }} &#8364;</b> Extra Charge will be
                      added.</span
                    >
                  </div>
                  <div class="pdt4" v-else>
                    <span style="font-weight: 500">
                      এক্সট্রা ফাস্ট ডেলিভারি পেতে চান?</span
                    >
                    <br />
                    <span style="color: #e91e63; font-weight: 400"
                      ><b> {{ extraFastDeliveryCharge }} &#8364;</b> অতিরিক্ত চার্জ যোগ
                      করা হবে।</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="order-items">
              <h3 class="c-title mb10" v-if="globalLanguage == 'EN'">Order Total</h3>
              <h3 class="c-title bn mb10" v-else>অর্ডার টোটাল</h3>
              <table class="table table-responsive table-striped checkout-table">
                <tbody>
                  <tr>
                    <td colspan="4" class="text-right" v-if="globalLanguage == 'EN'">
                      Sub Total
                    </td>
                    <td colspan="4" class="text-right bn" v-else>সাব টোটাল</td>
                    <td colspan="2" class="base-color w500">
                      {{ sum_cart_total }} &#8364;
                    </td>
                  </tr>
                  <tr>
                    <td colspan="4" class="text-right" v-if="globalLanguage == 'EN'">
                      Delivery Charge
                    </td>
                    <td colspan="4" class="text-right bn" v-else>ডেলিভারি চার্জ</td>
                    <td colspan="2" class="base-color w500">
                      <span v-if="sum_cart_total > 0 && extraFastCharge">
                        {{
                          parseFloat(delivery_charge) +
                          parseFloat(extraFastDeliveryCharge)
                        }}
                        &#8364;</span
                      >
                      <span v-else> {{ delivery_charge }} &#8364;</span>
                    </td>
                  </tr>
                  <tr v-if="coupon_discount > 0 && extraFastCharge == false">
                    <td colspan="4" class="text-right" v-if="globalLanguage == 'EN'">
                      Coupon Discount
                    </td>
                    <td colspan="4" class="text-right bn" v-else>কুপন ডিসকাউন্ট</td>
                    <td colspan="2" class="orange-color w500">
                      <span>- {{ coupon_discount }} &#8364;</span>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="4" class="text-right" v-if="globalLanguage == 'EN'">
                      Order Total Amount
                    </td>
                    <td colspan="4" class="text-right bn" v-else>টোটাল এমাউন্ট</td>
                    <td colspan="2" class="base-color">
                      <b v-if="sum_cart_total > 0 && extraFastCharge">
                        {{
                          sum_cart_total +
                          parseFloat(delivery_charge) +
                          parseFloat(extraFastDeliveryCharge) -
                          coupon_discount
                        }}
                        &#8364;</b
                      >
                      <b v-else>
                        {{
                          sum_cart_total + parseFloat(delivery_charge) - coupon_discount
                        }}
                        &#8364;</b
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="mt30 mb10">
              <button
                class="btn btn-base orderCompleteBtn pull-right"
                @click="checkout"
                v-if="globalLanguage == 'EN'"
              >
                Complete Order
              </button>
              <button
                class="btn btn-base orderCompleteBtn pull-right"
                @click="checkout"
                v-else
              >
                অর্ডার কমপ্লিট করুন
              </button>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
const $ = require("jquery");
window.$ = $;
$(function () {
  $(window).scroll(function () {
    $("nav").toggleClass("scrolled", $(this).scrollTop() > 50);
  });
});

import axios from "axios";
import moment from "moment";
import Select2 from "v-select2-component";

export default {
  // components: {Select2},
  data() {
    return {
      token: "",
      products: [],
      getcarts: [],
      carts: [],
      loadMore: true,
      isOpen: true,
      sum_cart_total: "",
      images: [],
      parseCartData: [],
      name: "",
      phone: "",
      area: null,
      coupon: "",
      shipping_address: "",
      previous_locations: [],
      payment_type: "",
      logged_in_user_name: "",
      transaction_number: "",
      delivery_charge: 0,
      coupon_discount: "",
      customer_id: "",
      password: "",
      showOTPInput: false,
      otpCode: "",
      buttonStatus: true,
      tokenIsValid: false,
      locations: [],
      getSearchAreaList: [],
      locationValue: "",
      extraFastDeliveryCharge: 0,
      extraFastCharge: false,
      final_delivery_charge: null,
      ShowextraFastDiv: false,
      delivery_location_id: null,
      min_order_amount: null,
      searchByName: null,
      toggle: false,
      productRestrictionBn: null,
      productRestrictionEn: null,
      couponBtn: false,
      responseBN: null,
      responseEN: null,
      isActiveTime: true,
      isActiveTomorrowTime: false,
      delivery_time_slot: null,
      expectedDeliveryTime: null,
      timeSlots: [],
      tomorrow: new Date(+new Date() + 86400000),
      expectedDeliveryStartTime: null,
      expectedDeliveryEndTime: null,
      DeliveryFinalDateTime: null,
      expectedDeliveryTimeEnable: null,
    };
  },
  async created() {
    //localStorage.clear();
    await this.fetchUserInfo();
    //this.deliveryCharge();
    await this.setUserID();
    await this.deliveryLocations();
  },
  mounted() {
    // this.getImagesInfo()
    let vm = this;
    if (localStorage.getItem("token")) {
      let vm = this;
      vm.token = localStorage.getItem("token");
    }
    if (localStorage.getItem("carts")) {
      vm.carts = JSON.parse(localStorage.getItem("carts"));
    } else {
      vm.carts = [];
    }
    this.calculateCartTotal();
  },
  watch: {
    coupon: function () {
      let vm = this;
      if (this.coupon.length > 1) {
        vm.couponBtn = true;
      } else {
        vm.couponBtn = false;
      }
    },
    searchByName: function () {
      let vm = this;
      // console.log(vm.searchByName);
      let getSearchAreaList = vm.locations.filter(function (x) {
        return x.text.toLowerCase().indexOf(vm.searchByName.toLowerCase()) > -1;
      });
      vm.getSearchAreaList = getSearchAreaList;
      //console.log(getSearchAreaList);
    },
  },
  methods: {
    DeliveryTimeSet: function (index, delivery_time_from, delivery_time_to, day) {
      this.extraFastCharge = false;
      this.expectedDeliveryTimeEnable = null;
      if (day == "Tomorrow") {
        this.expectedDeliveryTime =
          day + " " + moment(String(this.tomorrow)).format("ddd");
        this.expectedDeliveryStartTime = delivery_time_from;
        this.expectedDeliveryEndTime = delivery_time_to;
      } else {
        this.expectedDeliveryTime = day;
        this.expectedDeliveryStartTime = delivery_time_from;
        this.expectedDeliveryEndTime = delivery_time_to;
      }
      this.isActiveTime = false;
      if (this.expectedDeliveryTime) {
        if (this.globalLanguage == "EN") {
          this.$toasted.show("Delivery Time Set Successfully.", {
            type: "success",
            icon: "fa-check-circle",
            duration: 1000,
          });
        } else {
          this.$toasted.show("ডেলিভারি সময় সফলভাবে সেট করা হয়েছে।", {
            type: "success",
            icon: "fa-check-circle",
            duration: 1000,
          });
        }
      }
    },
    toogleTimeArea: function () {
      this.isActiveTime = !this.isActiveTime;
    },
    ToogleTomorrowTime: function () {
      this.isActiveTomorrowTime = !this.isActiveTomorrowTime;
    },
    searchArea: function () {
      let vm = this;
      // console.log(vm.searchByName);
      let getSearchAreaList = vm.locations.filter(function (x) {
        return x.text.toLowerCase().indexOf(vm.searchByName.toLowerCase()) > -1;
      });
      vm.getSearchAreaList = getSearchAreaList;
    },
    extraFastChargeAssign: function () {
      let vm = this;
      if (vm.extraFastCharge == true) {
        vm.extraFastCharge = false;
        vm.expectedDeliveryTimeEnable = null;
      } else {
        vm.expectedDeliveryTimeEnable = "Extra Fast Delivery.";
        vm.extraFastCharge = true;
        vm.coupon_discount = null;
        vm.coupon = null;
        this.$toasted.show("You have chosen Extra Fast Delivery.", {
          type: "success",
          icon: "fa-check-circle",
          duration: 1000,
        });
      }
    },
    setUserID: function () {
      this.logged_in_user_name = localStorage.getItem("logged_in_user_name");
      this.token = localStorage.getItem("token");
    },
    focusInput: function () {
      if (this.toggle == true) {
        this.toggle = false;
      } else {
        this.toggle = true;
      }
      this.$nextTick(function () {
        this.$refs.search.focus();
      });
    },
    useThisAddress: function (address) {
      let vm = this;
      // alert(address);
      $("textarea#address").val(address);
      this.$toasted.show("Address Set Successfully.", {
        type: "success",
        icon: "fa-check-circle",
        duration: 1000,
      });
    },
    deliveryTimeSlotEnable: function (delivery_time_slot, buffering_time_slot) {
      let vm = this;
      // console.log('buffering_time_slot',buffering_time_slot);
      if (delivery_time_slot) {
        this.delivery_time_slot = delivery_time_slot.split(",");
      } else {
        this.delivery_time_slot = delivery_time_slot;
      }

      this.ShowextraFastDiv = true;
      // console.log(vm.delivery_time_slot);
      if (vm.delivery_time_slot) {
        for (let i = 0; i < vm.delivery_time_slot.length; i++) {
          // console.log(vm.delivery_time_slot[i]);
          const timeArray = vm.delivery_time_slot[i].split("-");
          // alert(typeof timeArray);
          // console.log(timeArray);
          if (timeArray === undefined || timeArray.length == 0) {
          } else {
            //present  hour value
            let startTime = timeArray[0];
            // console.log(startTime);
            let endTime = timeArray[1];
            var today = new Date();
            if (buffering_time_slot) {
              var now = moment().format("h:mma");
            } else {
              var now = moment().format("h:mma");
            }
            let momentObj = moment(startTime, ["h:mm"]);
            let FinalStartTime = momentObj
              .add(buffering_time_slot, "minutes")
              .format("h:mma");
            var SetStartTime = moment(FinalStartTime, "h:mma");
            var beginningTime = moment(SetStartTime, "h:mma");
            var now = moment(now, "h:mma");

            if (beginningTime.isBefore(now) === false) {
              vm.timeSlots.push({
                start: startTime,
                end: endTime,
                status: false,
              });
            } else {
              vm.timeSlots.push({
                start: startTime,
                end: endTime,
                status: true,
              });
            }
          }
        }
      }
      //alert(this.delivery_charge);
      // console.log(this.coupon);
      this.toggle = false;
    },
    deliveryLocations: function () {
      let vm = this;
      if (JSON.parse(localStorage.getItem("logged_in_user_id")) != null) {
        axios
          .get(
            this.globalUrl +
              "delivery-locations/" +
              JSON.parse(localStorage.getItem("logged_in_user_id"))
          )
          .then(function (response) {
            //console.log(response);
            response.data.locations.forEach((element) =>
              vm.locations.push({
                location_id: element.location_id,
                delivery_charge: element.delivery_charge,
                min_order_amount: element.min_order_amount,
                extraFastDeliveryCharge: element.extra_fast_delivery_charge,
                location_name_en: element.location_name,
                text: element.location_name + "- " + element.location_name_bn,
                delivery_time_slot: element.delivery_time_slot,
                buffering_time_slot: element.buffering_time_slot,
              })
            );

            vm.previous_locations = response.data.previous_locations;
            vm.getSearchAreaList = vm.locations;
            //let  previous_area= response.data.previous_area.area.substr(0, response.data.previous_area.area.indexOf('-'));
            let previous_area = response.data.previous_area.area;
            let trim_area = previous_area.trim();
            const select_my_area = vm.locations.find(
              (element) => element.location_name_en == trim_area
            );

            // let select_my_area=vm.locations.filter(function(x) {
            //   return x.location_name_en.toLowerCase().indexOf(trim_area.toLowerCase()) > -1;
            // });
            //console.log('select_my_area', Object.values(select_my_area));
            let my = Object.values(select_my_area);
            // console.log('my-location', my);
            //console.log('location_id', my[0]);
            // console.log(my[0].delivery_charge);
            // console.log(my[0].location_name_en);
            //console.log(my[0]);
            vm.area = my[5];
            // alert(my[5]);
            vm.delivery_location_id = my[0];
            vm.min_order_amount = my[2];
            vm.delivery_charge = my[1];
            vm.extraFastDeliveryCharge = my[3];
            vm.ShowextraFastDiv = true;
            let delivery_time_slot = my[6];
            let buffering_time_slot = my[7];
            // alert(buffering_time_slot);
            vm.deliveryTimeSlotEnable(delivery_time_slot, buffering_time_slot);
          })
          .catch((error) => {});
      } else {
        axios
          .get(this.globalUrl + "all-delivery-locations")
          .then(function (response) {
            //console.log(response.data);

            response.data.locations.forEach(
              (element) =>
                //console.log( element.delivery_charge)
                vm.locations.push({
                  location_id: element.location_id,
                  delivery_charge: element.delivery_charge,
                  min_order_amount: element.min_order_amount,
                  extraFastDeliveryCharge: element.extra_fast_delivery_charge,
                  location_name_en: element.location_name,
                  text: element.location_name + "- " + element.location_name_bn,
                  delivery_time_slot: element.delivery_time_slot,
                  buffering_time_slot: element.buffering_time_slot,
                })
              //this will use for search
            );
            vm.getSearchAreaList = vm.locations;
            //console.log(vm.locations);
          })
          .catch((response) => {
            //console.log(response);
            vm.$toasted.show("Something wrong  Refresh again.", {
              type: "error",
              icon: "fa-exclamation-triangle",
            });
          });
      }
    },
    verifyOTP: function () {
      //console.log(this.your_name);
      if (this.otpCode.length == 4) {
        axios
          .post(
            this.globalUrl + "verify-otp-token",
            {
              phone: this.phone,
              token: this.otpCode,
            },
            { crossdomain: true }
          )
          .then((response) => {
            //this.$refs['loginModal'].show();
            //console.log(response);
            if (response.data.status == 30) {
              $("#tokenSuccess").html(response.data.message);
              this.buttonStatus = false;
              this.tokenIsValid = true;
              $(".tokenField").addClass("success");
              $(".checkephone").prop("readonly", true);
              $(".tokenField").prop("readonly", true);
            } else if (response.data.status == 31) {
              $("#tokenSuccess").html(response.data.message);
              // $(".tokenField").prop("readonly", false);
              //   $(".tokenField").removeClass("success");
              // $(".checkephone,.tokenField").prop("readonly", false);
            }
          })
          .catch((response) => {
            //console.log(response);
            $("#tokenSuccess").html(response.data.message);
          });
      }
    },
    sendOTPCode: function () {
      //console.log(this.your_name);
      if (this.phone) {
        $("#OtpSuccess").show("slow");
        let check = this.phone.match(/^\d{10}$/);
        //console.log(check);
        if (check != null) {
          $(".otpbtn").addClass("disabled");
          $(".otpbtn").append(" <i class='fa fa-spinner fa-spin'></i>");
          setTimeout(function () {
            $(".otpbtn").removeClass("disabled");
            $(".otpbtn").html('<i class="fa fa-rocket"></i>&nbsp; Send OTP Code');
          }, 5000);
          axios
            .post(
              this.globalUrl + "send-otp-token",
              {
                phone: this.phone,
              },
              { crossdomain: true }
            )
            .then((response) => {
              //this.$refs['loginModal'].show();
              //console.log(response);
              $("#OtpSuccess").html(response.data.message);
              setTimeout(function () {
                $("#OtpSuccess").fadeOut("slow");
              }, 10000); // <-- time in milliseconds
              if (response.data.status == 10) {
                this.showOTPInput = true;
                $("#OtpSuccess").addClass("otpmessage");
              }
            })
            .catch((response) => {
              //console.log(response);
              $("#OtpSuccess").html(response.data.message);
            });
        } else {
          this.$toasted.show("Phone number is not valid.", {
            type: "error",
            icon: "fa-exclamation-triangle",
            duration: 10000,
          });
        }
      } else {
        $("#OtpSuccess").html(
          "<span class='red-color'><i class='fa fa-exclamation-triangle'></i> PLease insert valid Phone Number</span>"
        );
      }
    },
    phoneNumbers: function () {
      let phone = this.phone;
      //console.log(phone);
      // let check = phone.match(/^(?:\+?88)?01[15-9]\d{8}$/);
      let check = phone.match(/^\d{10}$/);
       console.log(check);
      if (check === null) {
        $(".checkephone").removeClass("success");
        $(".checkephone").addClass("error");
      } else {
        $(".checkephone").removeClass("error");
        $(".checkephone").addClass("success");
      }
    },
    validate: function () {
      let vm = this;

      //console.log('min_order_amount',vm.min_order_amount);
      if (this.sum_cart_total >= vm.min_order_amount) {
        if (vm.extraFastCharge == false) {
          $(".minimum_order").text("");
          axios
            .post(
              this.globalUrl + "validate_coupon_test",
              {
                coupon: this.coupon,
                delivery_charge: vm.delivery_charge,
                sum_cart_total: vm.sum_cart_total,
                carts: this.carts,
              },
              { crossdomain: true }
            )
            .then((response) => {
              vm.productRestrictionEn = null;
              vm.productRestrictionBn = null;
              vm.responseBN = null;
              vm.responseEN = null;
              vm.coupon_discount = response.data.coupon_discount;
              if (response.data.message_bn) {
                vm.responseBN = response.data.message_en;
                vm.responseEN = response.data.message_bn;
              }
              if (response.data.not_valid_for_product_name) {
                let bn_not_valid_for_products = response.data.not_valid_for_product_name;
                let en_not_valid_for_product_name =
                  response.data.en_not_valid_for_product_name;
                let bn_productArray = Object.values(bn_not_valid_for_products);
                let en_productArray = Object.values(en_not_valid_for_product_name);
                vm.productRestrictionEn = en_productArray;
                vm.productRestrictionBn = bn_productArray;
              }
            })
            .catch((response) => {
              vm.coupon_discount = 0;
              vm.productRestrictionEn = null;
              vm.productRestrictionBn = null;
            });
        } else {
          $(".minimum_order").text("Coupon Code Not valid for extra Fast delivery.");
        }
      } else {
        vm.coupon_discount = "";
        $(".minimum_order").text(
          "Order Minimum " + vm.min_order_amount + "Taka to get Discount for your area."
        );
      }
    },
    deliveryCharge: function (
      location_id,
      delivery_charge,
      min_order_amount,
      extraFastDeliveryCharge,
      location_name,
      delivery_time_slot,
      buffering_time_slot
    ) {
      let vm = this;
      vm.timeSlots = [];
      // console.log(4, buffering_time_slot);
      // for (let index = 0; index < delivery_time_slot.length; ++index) {
      // const element = delivery_time_slot[index];

      this.expectedDeliveryTime = null;
      this.delivery_location_id = location_id;
      this.extraFastDeliveryCharge = extraFastDeliveryCharge;
      this.delivery_charge = delivery_charge;
      this.min_order_amount = min_order_amount;
      this.area = location_name;
      this.deliveryTimeSlotEnable(delivery_time_slot, buffering_time_slot);

      if (this.globalLanguage == "EN") {
        this.$toasted.show("Area Set Successfully.", {
          type: "success",
          icon: "fa-check-circle",
          duration: 1000,
        });
      } else {
        this.$toasted.show("এলাকা সফলভাবে সেট করা হয়েছে।", {
          type: "success",
          icon: "fa-check-circle",
          duration: 1000,
        });
      }
      if (this.coupon.length > 0) {
        //console.log('ok');
        this.validate();
      }
    },
    fetchUserInfo() {
      if (localStorage.getItem("userinfo")) {
        this.name = JSON.parse(localStorage.getItem("userinfo")).name;
        this.phone = JSON.parse(localStorage.getItem("userinfo")).phone;
        //this.area = JSON.parse(localStorage.getItem("userinfo")).area;
      }
    },
    calculateCartTotal() {
      let vm = this;
      for (var i = 0, sum = 0; i < vm.carts.length; sum += vm.carts[i++].subtotal);
      vm.sum_cart_total = sum;
      //calculate total  product  amount
      for (
        var i = 0, totalSum = 0;
        i < vm.carts.length;
        totalSum += vm.carts[i++].cart_quantity
      );
      vm.cartsCountProduct = totalSum;
      localStorage.setItem("cartsCountProduct", totalSum);
      $(".carts .badge").text(vm.carts.length);
    },
    getProfile() {
      let vm = this;

      axios
        .get(this.globalUrl + "user", {
          headers: { Authorization: localStorage.getItem("token") },
        })
        .then((response) => {
          //console.log('userinfo',response.data);
          localStorage.setItem("logged_in_user_id", response.data.user.id);
          localStorage.setItem("logged_in_user_name", response.data.user.name);
          localStorage.setItem("userinfo", JSON.stringify(response.data.user));
          localStorage.setItem("is_seller", JSON.stringify(response.data.is_seller));

          vm.$router.go("/");
          //vm.$parent.endLoading();
          //vm.$router.push('/products');
          //this.$router.go(this.$router.currentRoute);
          // vm.$router.go('/');
        })
        .catch((response) => {});
      //console.log("token:" + vm.token);
    },
    LoggedInUserOrder: function () {
      let vm = this;

      let expectedDeliveryTime = $(".expectedDeliveryTime").text();
      // alert(expectedDeliveryTime);
      axios
        .post(
          this.globalUrl + "orders-test",
          {
            customer_id: this.customer_id,
            cart_total: this.sum_cart_total,
            name: this.name,
            phone: this.phone,
            password: this.password,
            delivery_charge: vm.final_delivery_charge,
            area_id: this.delivery_location_id,
            area: this.delivery_location_id + "+" + this.delivery_charge,
            shipping_address: this.shipping_address,
            // shipping_address: this.shipping_address,
            payment_type: this.payment_type,
            transaction_number: this.transaction_number,
            coupon: this.coupon,
            coupon_discount: this.coupon_discount,
            delivery_time: expectedDeliveryTime,
            data: this.carts,
          },
          {
            crossdomain: true,
            headers: {
              Authorization: this.token,
            },
          }
        )
        .then((response) => {
          this.$router.push("/myorders");
          vm.$parent.endLoading();
          this.$toasted.show("Your Order Has  been created  successfully.", {
            type: "success",
            icon: "fa-check-circle",
            duration: 10000,
          });
          localStorage.removeItem("carts");
          this.carts = [];

          //console.log(response);
        })
        .catch((response) => {
          setTimeout(function () {
            $(".orderCompleteBtn").removeClass("disabled");
            $(".orderCompleteBtn").empty();
            if (this.globalLanguage == "EN") {
              $(".orderCompleteBtn").text("COMPLETE ORDER");
            } else {
              $(".orderCompleteBtn").text("অর্ডার কমপ্লিট   করুন ");
            }
          }, 500);
          //console.log(response);
          //vm.$parent.endLoading();
          this.$toasted.show("Something Wrong Please Try again..", {
            type: "error",
            icon: "fa-exclamation-triangle",
          });
        });
    },
    NewUSerOrder: function () {
      let vm = this;
      let expectedDeliveryTime = $(".expectedDeliveryTime").text();
      // console.log(expectedDeliveryTime);
      axios
        .post(
          this.globalUrl + "orders-test",
          {
            customer_id: this.customer_id,
            cart_total: vm.sum_cart_total,
            name: this.name,
            phone: this.phone,
            password: this.password,
            delivery_charge: vm.final_delivery_charge,
            area_id: this.delivery_location_id,
            area: this.delivery_location_id + "+" + this.delivery_charge,
            shipping_address: this.shipping_address,
            payment_type: this.payment_type,
            transaction_number: this.transaction_number,
            coupon: this.coupon,
            coupon_discount: vm.coupon_discount,
            delivery_time: expectedDeliveryTime,
            // delivery_time:    vm.expectedDeliveryTimeEnable + expectedDeliveryTime + expectedDeliveryStartTime + expectedDeliveryEndTime,
            data: this.carts,
          },
          { crossdomain: true }
        )
        .then((response) => {
          if (JSON.parse(localStorage.getItem("logged_in_user_id"))) {
            this.$router.push("/myorders");
          } else {
            axios
              .post(
                this.globalUrl + "login",
                {
                  phone: this.phone,
                  password: this.password,
                },
                { crossdomain: true }
              )
              .then((response) => {
                localStorage.setItem("token", "Bearer " + response.data.token);
                //console.log(localStorage.getItem("token"));

                axios
                  .get(this.globalUrl + "user", {
                    headers: { Authorization: localStorage.getItem("token") },
                  })
                  .then((response) => {
                    //console.log(response.data);
                    localStorage.setItem("logged_in_user_id", response.data.user.id);
                    localStorage.setItem("logged_in_user_name", response.data.user.name);
                    localStorage.setItem("userinfo", JSON.stringify(response.data.user));
                    this.$router.push("/myorders");
                    vm.$router.go("/");
                    vm.$parent.endLoading();
                  })
                  .catch((response) => {});
              });
          }
          vm.$parent.endLoading();
          this.$toasted.show("Your Order Has  been created  successfully.", {
            type: "success",
            icon: "fa-check-circle",
            duration: 10000,
          });
          localStorage.removeItem("carts");
          this.carts = [];
        })
        .catch((response) => {
          setTimeout(function () {
            $(".orderCompleteBtn").removeClass("disabled");
            $(".orderCompleteBtn").empty();
            if (this.globalLanguage == "EN") {
              $(".orderCompleteBtn").text("COMPLETE ORDER");
            } else {
              $(".orderCompleteBtn").text("অর্ডার কমপ্লিট   করুন ");
            }
          }, 500);
          this.$toasted.show("Something Wrong Check all fields", {
            type: "error",
            icon: "fa-exclamation-triangle",
          });
        });
    },
    checkout: function (e) {
      e.preventDefault();
      $(".orderCompleteBtn").addClass("disabled");
      $(".orderCompleteBtn").append("<i class='fa fa-spinner fa-spin'></i>");
      let vm = this;
      this.shipping_address = $(".shipping_address").val();
      //alert(this.expectedDeliveryTime + this.expectedDeliveryStartTime  + this.expectedDeliveryEndTime )

      if (
        this.name != "" &&
        this.phone.length == 10 &&
        this.delivery_location_id &&
        this.shipping_address != "" &&
        this.payment_type != ""
      ) {
        if (this.payment_type == 3) {
          if (!this.transaction_number) {
            setTimeout(function () {
              $(".orderCompleteBtn").removeClass("disabled");
              $(".orderCompleteBtn").empty();
              if (this.globalLanguage == "EN") {
                $(".orderCompleteBtn").text("COMPLETE ORDER");
              } else {
                $(".orderCompleteBtn").text("অর্ডার কমপ্লিট   করুন ");
              }
            }, 500);
            this.$toasted.show("Please Input your Nagad Number.", {
              type: "error",
              icon: "fa-exclamation-triangle",
            });
            return;
          }
        }
        if (JSON.parse(localStorage.getItem("logged_in_user_id"))) {
          this.customer_id = JSON.parse(localStorage.getItem("logged_in_user_id"));
        }
        if (this.customer_id == "") {
          if (
            this.buttonStatus == false &&
            this.password.length > 5 &&
            this.tokenIsValid == true
          ) {
            if (vm.extraFastCharge == true) {
              vm.final_delivery_charge =
                parseFloat(this.delivery_charge) +
                parseFloat(this.extraFastDeliveryCharge);
            } else {
              vm.final_delivery_charge = this.delivery_charge;
            }
            if (vm.timeSlots.length > 0) {
              if (vm.expectedDeliveryTime) {
                this.NewUSerOrder();
              } else {
                setTimeout(function () {
                  $(".orderCompleteBtn").removeClass("disabled");
                  $(".orderCompleteBtn").empty();
                  if (this.globalLanguage == "EN") {
                    $(".orderCompleteBtn").text("COMPLETE ORDER");
                  } else {
                    $(".orderCompleteBtn").text("অর্ডার কমপ্লিট   করুন ");
                  }
                }, 500);
                this.$toasted.show("Set Your Delivery Time.", {
                  type: "error",
                  icon: "fa-exclamation-triangle",
                  duration: 10000,
                });
                $("html,body").animate(
                  {
                    scrollTop: $(".delivery_time_slot").offset().top,
                  },
                  "slow"
                );
                return;
              }
            } else {
              this.NewUSerOrder();
            }
          } else {
            if (this.password.length < 5) {
              setTimeout(function () {
                $(".orderCompleteBtn").removeClass("disabled");
                $(".orderCompleteBtn").empty();
                if (this.globalLanguage == "EN") {
                  $(".orderCompleteBtn").text("COMPLETE ORDER");
                } else {
                  $(".orderCompleteBtn").text("অর্ডার কমপ্লিট   করুন ");
                }
              }, 500);
              this.$toasted.show("Password Need to  be  min 6 character.", {
                type: "error",
                icon: "fa-exclamation-triangle",
              });
            }
            if (this.buttonStatus == true) {
              setTimeout(function () {
                $(".orderCompleteBtn").removeClass("disabled");
                $(".orderCompleteBtn").empty();
                if (this.globalLanguage == "EN") {
                  $(".orderCompleteBtn").text("COMPLETE ORDER");
                } else {
                  $(".orderCompleteBtn").text("অর্ডার কমপ্লিট   করুন ");
                }
              }, 500);
              this.$toasted.show("Verify Your Phone Number with Mobile token.", {
                type: "error",
                icon: "fa-exclamation-triangle",
              });
            }
            if (this.tokenIsValid == false) {
              setTimeout(function () {
                $(".orderCompleteBtn").removeClass("disabled");
                $(".orderCompleteBtn").empty();
                if (this.globalLanguage == "EN") {
                  $(".orderCompleteBtn").text("COMPLETE ORDER");
                } else {
                  $(".orderCompleteBtn").text("অর্ডার কমপ্লিট   করুন ");
                }
              }, 500);
              this.$toasted.show("Token is  not valid please try again.", {
                type: "error",
                icon: "fa-exclamation-triangle",
              });
            }
          }
        } else {
          if (vm.extraFastCharge == true) {
            vm.final_delivery_charge =
              parseFloat(this.delivery_charge) + parseFloat(this.extraFastDeliveryCharge);
          } else {
            vm.final_delivery_charge = this.delivery_charge;
          }
          if (vm.timeSlots.length > 0) {
            if (vm.expectedDeliveryTime) {
              this.LoggedInUserOrder();
            } else {
              setTimeout(function () {
                $(".orderCompleteBtn").removeClass("disabled");
                $(".orderCompleteBtn").empty();
                if (this.globalLanguage == "EN") {
                  $(".orderCompleteBtn").text("COMPLETE ORDER");
                } else {
                  $(".orderCompleteBtn").text("অর্ডার কমপ্লিট   করুন ");
                }
              }, 500);

              if (this.globalLanguage == "EN") {
                this.$toasted.show("Set Your Delivery Time.", {
                  type: "error",
                  icon: "fa-exclamation-triangle",
                  duration: 10000,
                });
              } else {
                this.$toasted.show("আপনার ডেলিভারি সময় সেট করুন", {
                  type: "success",
                  icon: "fa-check-circle",
                  duration: 1000,
                });
              }
              $("html,body").animate(
                {
                  scrollTop: $(".delivery_time_slot").offset().top - 80,
                },
                "slow"
              );
              return;
            }
          } else {
            this.LoggedInUserOrder();
          }
        }
        //localStorage.removeItem("carts");
        //this.carts = [];
      } else {
        if (!this.name) {
          setTimeout(function () {
            $(".orderCompleteBtn").removeClass("disabled");
            $(".orderCompleteBtn").empty();
            if (this.globalLanguage == "EN") {
              $(".orderCompleteBtn").text("COMPLETE ORDER");
            } else {
              $(".orderCompleteBtn").text("অর্ডার কমপ্লিট   করুন ");
            }
          }, 500);
          this.$toasted.show("Name can not be Blank.", {
            type: "error",
            icon: "fa-exclamation-triangle",
          });
        }
        if (!this.phone) {
          setTimeout(function () {
            $(".orderCompleteBtn").removeClass("disabled");
            $(".orderCompleteBtn").empty();
            if (this.globalLanguage == "EN") {
              $(".orderCompleteBtn").text("COMPLETE ORDER");
            } else {
              $(".orderCompleteBtn").text("অর্ডার কমপ্লিট   করুন ");
            }
          }, 500);
          this.$toasted.show("phone Number Can not Blank.", {
            type: "error",
            icon: "fa-exclamation-triangle",
          });
        }
        if (this.delivery_location_id != "") {
          setTimeout(function () {
            $(".orderCompleteBtn").removeClass("disabled");
            $(".orderCompleteBtn").empty();
            if (this.globalLanguage == "EN") {
              $(".orderCompleteBtn").text("COMPLETE ORDER");
            } else {
              $(".orderCompleteBtn").text("অর্ডার কমপ্লিট   করুন ");
            }
          }, 500);
          // this.$toasted.show('232Area Can not be Blank.', {
          //   type: 'error',
          //   icon: 'fa-exclamation-triangle'
          // });
        }
        if (this.delivery_charge < 1) {
          setTimeout(function () {
            $(".orderCompleteBtn").removeClass("disabled");
            $(".orderCompleteBtn").empty();
            if (this.globalLanguage == "EN") {
              $(".orderCompleteBtn").text("COMPLETE ORDER");
            } else {
              $(".orderCompleteBtn").text("অর্ডার কমপ্লিট   করুন ");
            }
          }, 500);
          // this.$toasted.show('Area Can not be Blank.', {
          //   type: 'error',
          //   icon: 'fa-exclamation-triangle'
          // });
        }
        if (!this.payment_type) {
          setTimeout(function () {
            $(".orderCompleteBtn").removeClass("disabled");
            $(".orderCompleteBtn").empty();
            if (this.globalLanguage == "EN") {
              $(".orderCompleteBtn").text("COMPLETE ORDER");
            } else {
              $(".orderCompleteBtn").text("অর্ডার কমপ্লিট   করুন ");
            }
          }, 500);

          if (this.globalLanguage == "EN") {
            this.$toasted.show("Choose Payment Option.", {
              type: "error",
              icon: "fa-exclamation-triangle",
            });
          } else {
            this.$toasted.show("পেমেন্ট অপশন নির্ধারণ করুন", {
              type: "error",
              icon: "fa-exclamation-triangle",
            });
          }
        }
        if (!this.shipping_address) {
          setTimeout(function () {
            $(".orderCompleteBtn").removeClass("disabled");
            $(".orderCompleteBtn").empty();
            if (this.globalLanguage == "EN") {
              $(".orderCompleteBtn").text("COMPLETE ORDER");
            } else {
              $(".orderCompleteBtn").text("অর্ডার কমপ্লিট   করুন ");
            }
          }, 500);

          if (this.globalLanguage == "EN") {
            this.$toasted.show("Set Shipping Address.", {
              type: "error",
              icon: "fa-exclamation-triangle",
            });
          } else {
            this.$toasted.show("শিপিং ঠিকানা নির্বাচন করুন", {
              type: "error",
              icon: "fa-exclamation-triangle",
            });
          }
        }
        if (this.phone) {
          if (this.phone.length != 10) {
            setTimeout(function () {
              $(".orderCompleteBtn").removeClass("disabled");
              $(".orderCompleteBtn").empty();
              if (this.globalLanguage == "EN") {
                $(".orderCompleteBtn").text("COMPLETE ORDER");
              } else {
                $(".orderCompleteBtn").text("অর্ডার কমপ্লিট   করুন ");
              }
            }, 500);
            this.$toasted.show("Input a valid Phone.", {
              type: "error",
              icon: "fa-exclamation-triangle",
            });
          }
        }
        if (!this.logged_in_user_name && !this.password) {
          setTimeout(function () {
            $(".orderCompleteBtn").removeClass("disabled");
            $(".orderCompleteBtn").empty();
            if (this.globalLanguage == "EN") {
              $(".orderCompleteBtn").text("COMPLETE ORDER");
            } else {
              $(".orderCompleteBtn").text("অর্ডার কমপ্লিট   করুন ");
            }
          }, 500);
          this.$toasted.show("Password  Is Required.", {
            type: "error",
            icon: "fa-exclamation-triangle",
          });
        }
      }
    },
  },
};
</script>
